export const display = {
  state: {
    showFilters: true,
    showLegend: true,
    zoomLevel: 5,
    lat: 63.43,
    lng: 10.39
  },

  actions: {
    toggleShowFilters({ commit }, data) {
      commit('setShowFilters', data.showFilters);
    },
    toggleLegendDisplay({ commit }, data) {
      commit('setShowLegend', data.showLegend);
    },
    applyZoomLevel({ commit }, data) {
      commit('setZoomLevel', data.zoomLevel);
    },
    applyLat({ commit }, data) {
      commit('setLat', data.lat);
    },
    applyLng({ commit }, data) {
      commit('setLng', data.lng);
    }
  },

  mutations: {
    setShowFilters(state, show) {
      state.showFilters = show;
    },
    setShowLegend(state, show) {
      state.showLegend = show;
    },
    setZoomLevel(state, zoomLevel) {
      state.zoomLevel = zoomLevel;
    },
    setLat(state, lat) {
      state.lat = lat;
    },
    setLng(state, lng) {
      state.lng = lng;
    }
  },

  getters: {
    getShowFilters(state) {
      return state.showFilters;
    },
    getShowLegend(state) {
      return state.showLegend;
    },
    getZoomLevel(state) {
      return state.zoomLevel;
    },
    getLat(state) {
      return state.lat;
    },
    getLng(state) {
      return state.lng;
    }
  }
};
